import { inject, Injectable } from '@angular/core';
import { CustomField } from '@enrollhere/classes';
import { EnrollhereApiService } from '../enrollhere-api/enrollhere-api';

interface AgencyCustomFieldResponse {
  agencyId: string;
  leadFields: unknown[];
  policyFields: unknown[];
}

export interface AgencyCustomFieldCatalog {
  agencyId: string;
  leadFields: CustomField[];
  policyFields: CustomField[];
}

@Injectable({ providedIn: 'root' })
export class AgencyCustomFieldService {
  private readonly apiService = inject(EnrollhereApiService);

  async getCatalog(agencyId: string): Promise<AgencyCustomFieldCatalog> {
    const response = await this.apiService.get<AgencyCustomFieldResponse>(
      `agency/${encodeURIComponent(agencyId)}/custom-fields`
    );
    return {
      agencyId: response.agencyId,
      leadFields: response.leadFields.map(field => CustomField.fromJSON(field)),
      policyFields: response.policyFields.map(field =>
        CustomField.fromJSON(field)
      ),
    };
  }
}
